import { Expose } from 'class-transformer';

export class SnNimbleUrls {
  @Expose({ name: 'qosSnapshot' })
  public qosSnapshot: string;
}
